import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import {BoxedContainer, TitleUppercase, Section} from '../../elements'

const Features = ({children, className}) => (
  <Section padding="bottom" className={className}>
    <BoxedContainer narrow>
      <StyledTitleUppercase>Features</StyledTitleUppercase>
      {children}
    </BoxedContainer>
  </Section>
)

export default Features

Features.propTypes = {
  children: PropTypes.node,
}

const StyledTitleUppercase = styled(TitleUppercase)`
  font-size: 1.6rem;
  margin: 0 0 25px;
`
